export var SPOTLIGHT_EXTENSION_TYPE = 'com.atlassian.confluence.spotlight';
export var SECTION_EXTENSION_TYPE = 'com.atlassian.confluence.hub-section';
export var RESOURCE_TILES_EXTENSION_TYPE = 'com.atlassian.confluence.knowledge-cards';
export var DEFAULT_BRANDING_COLOR = '#DDDEE1';
export var HUB_PRIMARY_COLOR_CSS_VAR = '--hub-primary-color';
export var HUB_PRIMARY_TEXT_COLOR_CSS_VAR = '--hub-primary-text-color';
export var SENTRY_DSN = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
export var UNKNOWN_TAG = 'unknown';